import React, { useEffect, useState } from 'react'
import { Document, Page, Text, View,Line } from '@react-pdf/renderer'
import { HoraActual, fechaActual } from '../../../hooks/UseDate'
import { postInformacionEmpresa } from '../../../services/PaginaRuta'

const PDFErroresSuministrosHG = ({dataErrorSuministros}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [informacionEmpresa,setinformacionEmpresa]=useState([])
  const datosEmpresa={
    "EMPCOD":usuarioInfo.Empresa,
    "MCDpto":usuarioInfo.Sede
}
  useEffect(() => {
    postInformacionEmpresa(datosEmpresa).then((res)=>{
      setinformacionEmpresa(res.data[0])
    })
  }, [])
   
  return (
    <Document>
    
    <Page size='A4' style={{padding: '50px' }}>
      <View>
      <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpNit}</Text>
      <Text style={{textAlign: 'center' , fontSize: 9}}>INCONSISTENCIAS EN GASTOS DE CIRUGÍA</Text>
        <Text><br /></Text>
        <Text style={{fontSize: 8}}>Fecha: {fechaActual()}</Text>
        <Text style={{fontSize: 8}}>Hora: {HoraActual()}</Text>
        <View style={{ marginTop: 2, borderTop: '1pt solid #000', marginTop: 4,}} />
        
        {dataErrorSuministros.map((item,index )=> (
          
              <Text style={{fontSize: 8}} key={index}>{'\n'}* {item} </Text>
              
        ))
        }
         
      </View>
    </Page>
    
    
      
</Document>   
  )
}

export default PDFErroresSuministrosHG